module.exports = __webpack_public_path__ + "static/media/AF.e287a0c3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/AF.svg
// module id = 2095
// module chunks = 7